'use strict';

var _objectSpread = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");

var WriteError = require('level-errors').WriteError;

var catering = require('catering');

var getCallback = require('./common').getCallback;

var getOptions = require('./common').getOptions;

function Batch(levelup) {
  this.db = levelup;
  this.batch = levelup.db.batch();
  this.ops = [];
  this.length = 0;
}

Batch.prototype.put = function (key, value, options) {
  try {
    this.batch.put(key, value, options);
  } catch (e) {
    throw new WriteError(e);
  }

  this.ops.push(_objectSpread(_objectSpread({}, options), {}, {
    type: 'put',
    key: key,
    value: value
  }));
  this.length++;
  return this;
};

Batch.prototype.del = function (key, options) {
  try {
    this.batch.del(key, options);
  } catch (err) {
    throw new WriteError(err);
  }

  this.ops.push(_objectSpread(_objectSpread({}, options), {}, {
    type: 'del',
    key: key
  }));
  this.length++;
  return this;
};

Batch.prototype.clear = function () {
  try {
    this.batch.clear();
  } catch (err) {
    throw new WriteError(err);
  }

  this.ops = [];
  this.length = 0;
  return this;
};

Batch.prototype.write = function (options, callback) {
  var levelup = this.db;
  var ops = this.ops;
  callback = getCallback(options, callback);
  callback = catering.fromCallback(callback);
  options = getOptions(options);

  try {
    this.batch.write(options, function (err) {
      if (err) {
        return callback(new WriteError(err));
      }

      levelup.emit('batch', ops);
      callback();
    });
  } catch (err) {
    throw new WriteError(err);
  }

  return callback.promise;
};

module.exports = Batch;